import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true, // Primary auth path — httpOnly `access_token` / `customer_token` cookies
});

// Belt+suspenders: also attach a Bearer token from localStorage if present.
// The httpOnly cookie is the primary/secure auth vector; this fallback exists so
// the app keeps working across sub-domains where cookies may be blocked and
// during E2E test suites that need a token they can inject. Refresh tokens are
// intentionally NEVER stored client-side.
api.interceptors.request.use((config) => {
  // Android's system captive-portal WebView runs pages in a restricted context
  // where localStorage access throws (SecurityError), not just returns empty —
  // an uncaught throw here would silently kill every single request through
  // this client, cookie-authed ones included. Storage is a pure bonus path, so
  // any failure here must never block the request itself.
  try {
    const token = localStorage.getItem("nhp_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch { /* storage blocked — cookie auth still applies */ }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
